
import { mapState } from "vuex";

import { PAGE_TYPE, PLP_QUERY } from "./-products.query";
import { seoMixin, pageMixin } from "~/mixins";

export default {
  mixins: [seoMixin, pageMixin],

  async asyncData({ app, params: { handle }, error }) {
    const { [PAGE_TYPE]: data } = await app.$getPrismicData({
      query: PLP_QUERY,
      variables: { uid: handle },
    });

    if (data?.collection == null || (data?.slices ?? []).length == 0) {
      return error({ statusCode: 404, message: "Page not found" });
    }

    const plpBanner = data.plp_banner_link;
    const bannerConfig = plpBanner?.display_banners
      ? {
          productTileBanners: [
            { image: plpBanner.image_1, image_link: plpBanner.image_1_link },
            { image: plpBanner.image_2, image_link: plpBanner.image_2_link },
          ].filter(({ image }) => image),
          heroBanner: {
            image: plpBanner.image,
            image_link: plpBanner.image_link,
          },
        }
      : null;

    return {
      title: data.title,
      uid: handle,
      pageType: PAGE_TYPE,
      slices: data.slices,
      metaTitle: data.metaTitle,
      metaDescription: data.metaDescription,
      metaRobots: data.metaRobots,
      metaFields: { _linkType: data._linkType, _meta: data._meta },
      context: { collection: data.collection, bannerConfig },
    };
  },

  computed: {
    ...mapState("app", ["isFilterPanelOpen"]),
  },

  beforeDestroy() {
    this.$store.dispatch("app/CLOSE_FILTER_PANEL");
  },
};
